// extracted by mini-css-extract-plugin
export default {"textContainer":"newSheetDetailsModal_textContainer__YkpWz","modalWidth":"newSheetDetailsModal_modalWidth__cki+7"};